import { apiSlice } from "../apiSlice";

export const termsAndConditionsMenuApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTermsAndConditionsMenu: builder.query({
      query: () => "terms_and_conditions/ddl",
      transformResponse: (responseData) => {
        const items = [];
        for (const main of responseData?.data ?? []) {
          items.push({ id: main.id, name: main.label, parent_id: null, level: 1 });
          for (const cat of main.categories ?? []) {
            items.push({ id: cat.id, name: cat.label, parent_id: main.id, level: 2 });
            for (const sub of cat.sub_categories ?? []) {
              items.push({ id: sub.id, name: sub.label, parent_id: cat.id, level: 3 });
            }
          }
        }
        return items;
      },
    }),
  }),
});

export const { useGetTermsAndConditionsMenuQuery } =
  termsAndConditionsMenuApiSlice;